import { lighterVariations } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';
export const StyledGoalImage = styled.div`
  position: absolute;
  z-index: 1;

  bottom: -19.5rem;
  right: 50%;
  transform: translateX(50%);
  width: 50rem;
  height: 50rem;

  img {
    width: 100%;
    height: 100%;
  }

  @media screen and (min-width: 576px) {
    top: 3.4rem;
    right: -11.4rem;
    transform: none;
  }

  @media screen and (min-width: ${({
  theme
}) => theme.sizes.md}) {
    top: -5.9rem;
    right: -14.8rem;
    transform: none;
    width: 63.7rem;
    height: 63.7rem;
  }
`;
export const StyledTooltip = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  & > div:first-of-type {
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translateX(-50%) translateY(-50%);
    width: fit-content;
    max-width: 22.5rem;

    background-color: ${lighterVariations.blue.darker};
    &:before {
      border-top-color: ${lighterVariations.blue.darker};
    }

    p {
      line-height: 2rem;
      text-align: center;
    }
`;
export const StyledCrownImage = styled.img`
  position: absolute;
  z-index: 1;

  transform: scaleX(-1);
  bottom: -5.9rem;
  width: 41.2rem;
  height: 25rem;

  @media screen and (min-width: 576px) {
    top: 18rem;
    right: -11rem;
  }

  @media screen and (min-width: ${({
  theme
}) => theme.sizes.md}) {
    top: 13.5rem;
    right: -12.0rem;
    transform: none;
    width: 48.6rem;
    height: 29.5rem;
  }
`;
export const StyledProfileImage = styled.div`
  position: absolute;
  z-index: 1;

  width: 25.6rem;
  height: 25.6rem;
  bottom: -4rem;
  right: -5.3rem;

  @media screen and (min-width: 576px) {
    width: 35.0rem;
    height: 35.0rem;
    bottom: -5rem;
    right: -7rem;
  }

  @media screen and (min-width: ${({
  theme
}) => theme.sizes.md}) {
    right: -3.5rem;
  }

  & > div {
    width: 100%;
    height: 100%;
  }
`;
export const AvatarCrown = styled.img`
  position: absolute;
  z-index: 1;

  transform: rotate(-29.5deg);

  width: 10rem;
  bottom: 23.0rem;
  right: 14.8rem;

  @media screen and (min-width: 576px) {
    width: 14rem;
    bottom: 31.2rem;
    right: 20.2rem;
  }
`;